import type {
  StripeConnectAccountRequest,
  StripeConnectAccountResponse,
  StripeConnectLinkRequest,
  StripeConnectLinkResponse,
} from '../types';
import type { RequestFn } from '../client';

export class StripeConnect {
  constructor(private readonly request: RequestFn) {}

  async createAccount(params: StripeConnectAccountRequest): Promise<StripeConnectAccountResponse> {
    return this.request('POST', '/connector-onboarding/stripe/accounts', { body: params });
  }

  async createAccountLink(params: StripeConnectLinkRequest): Promise<StripeConnectLinkResponse> {
    return this.request('POST', '/connector-onboarding/stripe/account-links', { body: params });
  }

  // --- Generic connector onboarding (Task 4.11) ---

  /** Get onboarding action URL. `POST /connector-onboarding/action-url` */
  async getActionUrl(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/connector-onboarding/action-url', { body: params });
  }

  /** Sync onboarding status. `POST /connector-onboarding/sync` */
  async syncOnboarding(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/connector-onboarding/sync', { body: params });
  }

  /** Reset tracking ID. `POST /connector-onboarding/reset-tracking-id` */
  async resetTrackingId(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/connector-onboarding/reset-tracking-id', { body: params });
  }
}
